import { faker } from '@faker-js/faker'

import { getAdminTreatmentItemOfRequestOption } from './TreatmentItemOfOption'

import { DiscountEligibility, RequestOption } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getRequestOption = asBuilder((): RequestOption => {
  const originalAmount = faker.number.int({ min: 10_000, max: 100_000 })
  const price = {
    originalAmount,
    discountedAmount: originalAmount - faker.number.int({ min: 1_000, max: 10_000 }),
  }
  return {
    id: faker.string.uuid(),
    name: faker.string.uuid(),
    price,
    treatments: {
      items: faker.helpers.multiple(getAdminTreatmentItemOfRequestOption),
    },
    pricePolicy: {
      discountCondition: {
        discountEligibility: faker.helpers.multiple(() => faker.helpers.enumValue(DiscountEligibility), {
          count: {
            min: 1,
            max: 3,
          },
        }),
        promotionalUseDiscount: {
          available: false,
          description: faker.string.sample(),
        },
      },
    },
    displayOrder: faker.number.int(),
  }
})
